import styled from 'styled-components';

export const MessageTextWrapper = styled.div`
`;
